import { Outlet } from 'react-router-dom'

import SettingsPageTemplate from '../settings/SettingsPageTemplate'

function SettingsPage() {
  return (
    <SettingsPageTemplate>
      <Outlet />
    </SettingsPageTemplate>
  )
}

export default SettingsPage
